import React, { useState, type FC } from 'react';
import styled from 'styled-components';
import ScrollableAnchor from 'react-scrollable-anchor';
import Container from '../../container';
import { Grid, Paragraph } from '../../UIKit/system';
import Title from '../../title';
import RichTextField from '../../rich-text-field';
import Button from '../../button';

interface ProductDescriptionProps {
  text?: {
    type: 'doc';
    content?: {
      type: 'paragraph' | 'unknown';
      content?: {
        type: 'text' | 'unknown';
        text: string;
      }[];
    }[];
  };
}

export const ProductDescription: FC<ProductDescriptionProps> = (props) => {
  const { text } = props;
  const [showMore, setSetMode] = useState(false);

  if (!text) return null;

  const firstParagraph = getFirstParagraph(text);

  if (!firstParagraph) return null;

  return (
    <ScrollableAnchor id="description">
      <Grid>
        <Container large mt={[48, 96]} mb={[48, 96]}>
          <SectionGrid>
            <Grid width={['auto', 180]} alignContent="start">
              <Title as="h2" fontSizeSmall>
                Description
              </Title>
            </Grid>

            <Paragraph fontSize={18} color="grey">
              {showMore ? (
                <RichTextField data={text} />
              ) : (
                <>
                  {firstParagraph}
                  <StyledReadMoreButton
                    onClick={(event) => {
                      event.preventDefault();
                      setSetMode(true);
                    }}
                  >
                    Read more
                  </StyledReadMoreButton>
                </>
              )}
            </Paragraph>
          </SectionGrid>
        </Container>
      </Grid>
    </ScrollableAnchor>
  );
};

const getFirstParagraph = (text: ProductDescriptionProps['text']) =>
  text?.content?.[0].type === 'paragraph' &&
  text.content[0].content?.[0].type === 'text' &&
  text.content[0].content[0].text;

const SectionGrid = styled(Grid).attrs(() => ({
  gridAutoFlow: ['row', 'row', 'column'],
  gridGap: [30, 30, 99],
  gridTemplateColumns: ['auto', 'auto', 'auto 1fr']
}))``;

const StyledReadMoreButton = styled(Button).attrs(() => ({
  to: '#',
  type: 'button',
  primaryTransparent: true
}))`
  display: inline-grid;
  font-size: inherit;
  font-weight: inherit;
  height: auto;
`;
